import { LitElement, html, unsafeCSS } from 'lit'
import { property } from 'lit/decorators.js'
import { getDaysUntilExpiration } from '@/utils/expiration'
import { t } from '@/i18n/translate-utils'
import styles from './gallery-header.styles.scss?inline'

/**
 * Header component for the GoTo Gallery SPA.
 *
 * Renders the gallery title and a contextual subtitle that either shows
 * the number of days until expiry or a plain no-expiry message.
 *
 * @prop title     - Gallery title text.
 * @prop senderName - Name of the sender (reserved for future use).
 * @prop expiresAt  - Expiry date, or `null` when there is no expiry.
 */
export class GalleryHeader extends LitElement {
  static readonly tagName = 'gallery-header'
  static styles = unsafeCSS(styles)

  @property({ type: String }) title = ''
  @property({ type: String }) senderName = ''
  @property({ attribute: false }) expiresAt: Date | null = null

  render() {
    const subtitle =
      this.expiresAt !== null
        ? t('gallery.header.expiry', 'Files sent via GoTo. Link expires in {{days}} days.', {
            days: getDaysUntilExpiration(this.expiresAt),
          })
        : t('gallery.header.expiryNoDate', 'Files sent via GoTo.')

    return html`
      <div class="header">
        <p class="subtitle">${subtitle}</p>
        <h1 class="title">${this.title}</h1>
      </div>
    `
  }
}
